import { IconChevronLeft as TablerIconChevronLeft } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconChevronLeft = /*#__PURE__*/ createOutlineIcon(
  TablerIconChevronLeft,
  'IconChevronLeft',
);
